import React from 'react';
import KitSignup from './KitSignup';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="site-header shell">
        <a className="wordmark" href="https://kevinchromik.de/" aria-label="Kevin Chromik – Website">
          kevin chromik.
        </a>
        <a className="website-link" href="https://kevinchromik.de/">
          Zur Website <span aria-hidden="true">↗</span>
        </a>
      </header>

      <main className="landing-main shell">
        <div className="hero-layout">
          <figure className="workbook-preview">
            <div className="cover-stage">
              <img
                src={process.env.PUBLIC_URL + '/cover.png'}
                alt="Cover des Workbooks Das 30-Tage-Framework von Kevin Chromik"
                className="cover-image"
                width="1690"
                height="2388"
              />
            </div>
            <figcaption>
              <p className="workbook-title">Das 30-Tage-Framework</p>
              <p className="workbook-detail">Mit Checklisten für jeden Schritt.</p>
            </figcaption>
          </figure>

          <section className="content" aria-labelledby="hero-title">
            <div className="author">
              <img
                src={process.env.PUBLIC_URL + '/profile.jpg'}
                alt=""
                className="author-avatar"
                width="36"
                height="36"
              />
              <span>von Kevin Chromik</span>
            </div>

            <h1 id="hero-title">
              In 30 Tagen<br />
              <span>von der Idee in den App Store.</span>
            </h1>
            <p className="subtitle">
              Hol dir das <strong>kostenlose</strong> Workbook und baue komplette Apps in Wochen, nicht Monaten.
            </p>

            <div className="form-container">
              <KitSignup />
              <p className="privacy-note">
                Mit der Anmeldung stimmst du zu, E-Mails von mir zu erhalten.
                Du kannst dich jederzeit abmelden.
              </p>
            </div>
          </section>
        </div>
      </main>

      <footer className="site-footer shell">
        <span>Kevin Chromik</span>
        <nav aria-label="Rechtliche Informationen">
          <a href="https://kevinchromik.de/impressum/">Impressum</a>
          <a href="https://kevinchromik.de/datenschutz/">Datenschutz</a>
        </nav>
      </footer>
    </div>
  );
}

export default App;
